import { tagAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys)

const variants = {
  subtle: definePartsStyle((props: StyleFunctionProps) => {
    const c = props.colorScheme ?? 'gray'
    return {
      container: {
        bg: mode(
          `color-mix(in srgb, var(--chakra-colors-${c}-100) 75%, transparent)`,
          `color-mix(in srgb, var(--chakra-colors-${c}-500) 35%, transparent)`
        )(props),
        color: 'default',
        borderRadius: 'full',
      },
    }
  }),
}

export default defineMultiStyleConfig({ variants })
